export default __webpack_public_path__ + "static/media/cycling.45540273.svg";